import * as React from 'react'
import styled from 'styled-components'
import { SizeChartDataAttributesValues } from 'modules/productDetail/types'
import genProductImageUrl from 'utils/genProductImageUrl'
import useTranslations from 'hooks/useTranslations'
import theme from 'theme'

type Props = {
  sizeChartLogoUrl: string
  sizeChartAttributes: Map<string, SizeChartDataAttributesValues>
}
export default function ProductInfo(props: Props) {
  const t = useTranslations<'templates-PDP'>()
  const measurementTutorialImage =
    genProductImageUrl(
      {
        url: props.sizeChartLogoUrl,
        classes: ['ASSET_FS']
      },
      'l'
    ) || ''
  const $measurementTutorialImageAlt = React.useRef<HTMLImageElement>(null)

  const getTranslationStringForSizeChartAttribute = (key: string) => {
    return 'sizeChart_' + key.toLowerCase() + '_info'
  }

  return (
    <Wrapper className="ProductInfo">
      <div className="measurement_tutorial_image_wrapper">
        <img
          className="measurement_tutorial_image"
          src={measurementTutorialImage}
          alt={t.asText(
            $measurementTutorialImageAlt,
            'sizeChart_measurement_tutorial_image_alt'
          )}
        />
      </div>
      <div className="description">
        <ol className="ordered_list">
          {Array.from(props.sizeChartAttributes)
            .sort((a, b) => a[1].sorting - b[1].sorting)
            .map(([key, value], index) => (
              <li key={index}>
                <p className="label">{value.label}</p>

                <p>
                  {
                    // The dynamic translation key is generating a Typescript error. And for good reason.
                    // The alternative would be to spell out all possible translation keys in a big switch case.
                    // I feel this variant is much more readable. If a translation can not be found,
                    // we will get an 'XXX-translate-me-XXX' output on the page. A reasonable fallback.
                    // @ts-ignore
                    t(getTranslationStringForSizeChartAttribute(key))
                  }
                </p>
              </li>
            ))}
        </ol>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;

  @media (max-width: ${theme.ms.MD}px) {
    align-items: center;
    flex-direction: column;
  }

  > .measurement_tutorial_image_wrapper {
    > .measurement_tutorial_image {
      width: 100%;
      max-width: 25rem;
      min-width: 18.75rem;
    }
  }

  > .description {
    > .ordered_list {
      margin: revert;
      padding: revert;
      list-style: decimal;

      li::marker {
        font-weight: bold;
      }

      > li {
        > .label {
          font-weight: bold;
        }
      }
    }
  }
`
